import { defineMessages } from 'react-intl';

export default defineMessages({
    hideCoverages:{
        id:'policy.cp.directives.policy-coverage-info.Hide Coverages',
        defaultMessage: 'Hide Coverages'
    },
    showCoverages:{
        id:'policy.cp.directives.policy-coverage-info.Show Coverages',
        defaultMessage: 'Show Coverages'
    },
    LiabilityLine: {
        id:'policy.cp.directives.policy-coverage-info.Liability and Extension',
        defaultMessage: 'Liability and Extension'
    },
    LocationName: {
        id: 'policy.cp.directives.policy-coverage-info.LocationwithName',
        defaultMessage: 'Location : {name}'
    },
    PackageName: {
        id: 'policy.cp.directives.policy-coverage-info.PackagewithName',
        defaultMessage: 'Package #{number} {type}'
    },
    CPCoverages: {
        id: 'policy.cp.directives.policy-coverage-info.Commercial Property Coverages',
        defaultMessage: 'Commercial Property Coverages'
    }
});
